const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.999,
    height: 13,
    viewBox: "0 0 12.999 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 240867"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 293011",
    d: "m141.568 35.791-1.928 1.928-3.64-3.64 1.928-1.928a.52.52 0 0 1 .735 0l2.9 2.9a.52.52 0 0 1 0 .737z",
    transform: "translate(-129.24 -31.478)",
    style: {
      opacity: 0.2,
      fill: "#033d9b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 293012",
    d: "m44.694 27.2-2.9-2.9a1.04 1.04 0 0 0-1.471 0L32.3 32.312a1.031 1.031 0 0 0-.3.735v2.9a1.04 1.04 0 0 0 1.04 1.04h2.9a1.031 1.031 0 0 0 .735-.3l8.015-8.015a1.04 1.04 0 0 0 .004-1.472zm-8.75 8.75h-2.9v-2.9l5.72-5.72 2.9 2.9zM42.4 29.5l-2.9-2.9 1.56-1.56 2.9 2.9z",
    transform: "translate(-32 -23.992)",
    style: {
      fill: "#033d9b"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.77e7b4801e65df43a55cad51635db030.svg";
export { ForwardRef as ReactComponent };